module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg3.a53dcfbb.png";